import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ReadonlyHttpApiRepository } from '@softline/core';
import { SOFTLINE_API_ABC_ANALYSIS_COLUMNS } from '../abc-analysis.api';
import { AbcAnalysisColumnsResponse } from '../types/abc-analysis-columns-response';

@Injectable()
export class AbcAnalysisColumnsRepository extends ReadonlyHttpApiRepository<
  AbcAnalysisColumnsResponse,
  undefined
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_ABC_ANALYSIS_COLUMNS);
  }
}
